import { render, staticRenderFns } from "./PlusAcademyActivity.vue?vue&type=template&id=d619ddf0&scoped=true"
import script from "./PlusAcademyActivity.vue?vue&type=script&lang=js"
export * from "./PlusAcademyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d619ddf0",
  null
  
)

export default component.exports